import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import logo from '@/assets/logo.jpg'
import NavItem from './NavItem'
import { NAV_LINKS } from '@/data/navigation'
import { useDonsModal } from '@/hooks/useDonsModal'

export default function Header() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const hasDarkHero = pathname === '/'
  const { open: openDonsModal } = useDonsModal()

  // Sur les pages sans hero sombre, la barre est toujours "scrolled" (pleine couleur) ;
  // sur l'accueil, ça dépend du scroll réel — d'où le calcul dérivé plutôt qu'un setState en écho.
  const [scrolledPastHero, setScrolledPastHero] = useState(false)
  const scrolled = !hasDarkHero || scrolledPastHero

  useEffect(() => {
    if (!hasDarkHero) return
    const onScroll = () => setScrolledPastHero(window.scrollY > 40)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [hasDarkHero])

  return (
    <header
      className={`fixed inset-x-0 z-40 text-white transition-all duration-300 ${
        scrolled
          ? 'top-0 bg-cmp-navy shadow-lg shadow-cmp-navy/10 border-b border-cmp-gold-light/20'
          : 'top-4 bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="CMP Lubumbashi"
            className="h-10 w-10 rounded-full object-cover ring-2 ring-white/20"
          />
          <span className="font-bold text-sm leading-tight">
            CMP
            <br />
            <span className="font-normal text-cmp-sky text-xs">Lubumbashi</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm">
          {NAV_LINKS.map((link) => (
            <NavItem key={link.label} {...link} className="hover:text-cmp-gold-light transition-colors" />
          ))}
          <button
            type="button"
            onClick={openDonsModal}
            className="bg-cmp-gold text-cmp-navy font-bold px-4 py-2 rounded-full hover:bg-cmp-gold-light transition-colors"
          >
            Offrande
          </button>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 -mr-2 hover:text-cmp-gold-light transition-colors"
          aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={open}
          aria-controls="mobile-nav-panel"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-nav-panel"
          className="md:hidden border-t border-white/10 bg-cmp-navy-dark px-4 py-3 flex flex-col"
        >
          {NAV_LINKS.map((link) => (
            <NavItem
              key={link.label}
              {...link}
              onClick={() => setOpen(false)}
              className="py-3 text-sm font-medium border-b border-white/5 hover:text-cmp-gold-light transition-colors"
            />
          ))}
          <button
            type="button"
            onClick={() => {
              setOpen(false)
              openDonsModal()
            }}
            className="mt-3 text-center bg-cmp-gold text-cmp-navy font-bold py-3 rounded-full hover:bg-cmp-gold-light transition-colors"
          >
            Offrande
          </button>
        </nav>
      )}
    </header>
  )
}
